import _get from 'lodash/get'
import _set from 'lodash/set'

export const createSetter = (key, defaultValue) => (state, value) => _set(state, key, (typeof value !== 'undefined' ? value : defaultValue))
export const createMappedClassSetter = (key, ClassValue) => (state, value) => (state[key] = value.map(v => new ClassValue(v)))
export const createGetter = (key) => (state) => _get(state, key)
